import type { Special } from "@/types/movie";

export const specials: Special[] = [
  {
    id: "special-scifi",
    title: "宇宙尽头的人类回响：2026 科幻片专题",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20collage%20style%20image%20of%20deep%20space%20with%20a%20lone%20spaceship%20and%20glowing%20planet%2C%20swirling%20nebula%2C%20warm%20gold%20and%20deep%20indigo%20tones%2C%20majestic%20sci%20fi%20mood&width=1200&height=600&seq=yp-special-01&orientation=landscape",
    intro:
      "当想象力冲出大气层，科幻电影便成了人类眺望未来的望远镜。本专题带你回顾年度最值得一看的科幻佳作。",
    editorNote:
      "编辑点评：这一年的科幻片不再只堆砌奇观，而是把镜头重新对准了“人”本身——记忆、孤独与选择，才是最宏大的宇宙。",
    articles: [
      {
        id: "art-01",
        title: "《星际回响》：用时间悖论，讲一个关于等待的故事",
        movieId: "star-echo",
        author: "影评人 白桦",
        date: "2026-10-11",
        excerpt:
          "当回信跨越光年传递，时间不再是刻度，而是思念的长度。影片把硬核设定包裹在柔软的情感里。",
      },
      {
        id: "art-02",
        title: "《时间褶皱》：在同一条街上，遇见无数个自己",
        movieId: "time-fold",
        author: "影评人 南山",
        date: "2026-10-05",
        excerpt:
          "导演用精密的叙事结构把“时间旅行”拍成了一场关于遗憾的迷宫，每一次改变都要付出代价。",
      },
      {
        id: "art-03",
        title: "《云上之城》：理想国的代价，从来不由设计者偿付",
        movieId: "city-above-clouds",
        author: "影评人 林深",
        date: "2026-09-27",
        excerpt:
          "乌托邦的外壳之下，是精密运转的代价。影片用一个工程师的视角，撕开了完美世界的裂缝。",
      },
      {
        id: "art-04",
        title: "《幻海浮生》：当记忆可以买卖，我们还剩下什么",
        movieId: "phantom-sea",
        author: "影评人 苏叶",
        date: "2026-09-19",
        excerpt:
          "文艺科幻的一次漂亮尝试，用漂浮的城市与可交易记忆，追问“我”究竟由什么定义。",
      },
    ],
  },
  {
    id: "special-thriller",
    title: "迷雾与真相：年度悬疑推理片深度专题",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20collage%20style%20image%20of%20a%20dim%20interrogation%20room%20and%20foggy%20night%20harbor%2C%20shafts%20of%20light%2C%20cold%20grey%20tones%20with%20amber%20accent%2C%20suspenseful%20mystery%20atmosphere&width=1200&height=600&seq=yp-special-02&orientation=landscape",
    intro:
      "真相往往藏在最不起眼的细节里。本专题精选年度悬疑推理佳作，带你复盘那些令人拍案叫绝的反转。",
    editorNote:
      "编辑点评：好的悬疑片不是把答案藏起来，而是让你在知道答案后，重新审视自己看过的每一个镜头。",
    articles: [
      {
        id: "art-05",
        title: "《第七个嫌疑人》：密室之内，谎言是最锋利的凶器",
        movieId: "seventh-suspect",
        author: "影评人 陈默",
        date: "2026-10-10",
        excerpt:
          "一场大雪困住七个人，也困住了一个真相。影片把本格推理的严谨与人性博弈的张力结合得恰到好处。",
      },
      {
        id: "art-06",
        title: "《无声证词》：沉默的孩子，说了最多的真话",
        movieId: "silent-testimony",
        author: "影评人 何夕",
        date: "2026-10-02",
        excerpt:
          "法庭题材的冷静与人物创伤的温度交织，影片证明了“不说”有时比“说”更有力量。",
      },
      {
        id: "art-07",
        title: "《暗流迷局》：多线叙事的野心与克制",
        movieId: "dark-current",
        author: "影评人 南山",
        date: "2026-09-24",
        excerpt:
          "影片用三条时间线编织出一张城市的隐秘之网，查案者终究发现自己也是网中之鱼。",
      },
    ],
  },
  {
    id: "special-warm",
    title: "人间烟火：年度温情与家庭题材专题",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20collage%20of%20a%20sunlit%20family%20home%20with%20sewing%20machine%20and%20a%20small%20town%20street%20at%20dusk%2C%20soft%20golden%20light%2C%20nostalgic%20tender%20mood&width=1200&height=600&seq=yp-special-03&orientation=landscape",
    intro:
      "有些电影不讲惊天动地，只讲一日三餐与一盏灯。本专题聚焦那些让你想起家人与故乡的温暖之作。",
    editorNote:
      "编辑点评：真正能打动人的，从来不是宏大叙事，而是某个瞬间让你突然想给家里打个电话。",
    articles: [
      {
        id: "art-08",
        title: "《母亲的针脚》：一针一线，缝住了一辈子的心事",
        movieId: "mother-stitch",
        author: "影评人 苏叶",
        date: "2026-10-08",
        excerpt:
          "影片把最朴素的动作拍成最深的告白，看完之后，你会想重新认真看看母亲的手。",
      },
      {
        id: "art-09",
        title: "《山河故梦》：与土地相伴的人，从不认为自己伟大",
        movieId: "mountain-dream",
        author: "影评人 白桦",
        date: "2026-09-30",
        excerpt:
          "三代守林人的故事没有高声呐喊，只有群山之间的沉默坚守，却足以让人热泪盈眶。",
      },
      {
        id: "art-10",
        title: "《小城故事多》：老面馆里，装着整条街的悲欢",
        movieId: "small-town",
        author: "影评人 林深",
        date: "2026-09-22",
        excerpt:
          "没有反转，没有高潮，只有一碗热面与熟客的寒暄，却把人间烟火拍得有滋有味。",
      },
    ],
  },
];